/* LADDOM mega menu (§3) — hover intent, keyboard, instant swap.
   Getting the intent buffer wrong is the most common mega-menu defect:
   a diagonal mouse path toward the panel must not close it. */
(function () {
  'use strict';

  var OPEN_DELAY = 120;
  var CLOSE_GRACE = 180;

  function initMega(root) {
    if (!root || root.dataset.megaReady === '1') return;
    root.dataset.megaReady = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-mega-item]'))
      .filter(function (i) { return i.querySelector('[data-mega-panel]'); });
    if (!items.length) return;

    var openTimer = null;
    var closeTimer = null;
    var current = null;

    function panelOf(item) { return item.querySelector('[data-mega-panel]'); }
    function triggerOf(item) { return item.querySelector('[data-mega-trigger]'); }

    function show(item, instant) {
      window.clearTimeout(closeTimer);
      if (current === item) return;

      // Already-open panel: swap contents with no re-fade.
      if (current && instant !== false) {
        root.classList.add('is-swapping');
        window.setTimeout(function () { root.classList.remove('is-swapping'); }, 50);
      }

      if (current) hide(current, true);

      item.classList.add('is-open');
      var p = panelOf(item);
      if (p) p.hidden = false;
      var t = triggerOf(item);
      if (t) t.setAttribute('aria-expanded', 'true');
      current = item;
    }

    function hide(item, immediate) {
      if (!item) return;
      item.classList.remove('is-open');
      var t = triggerOf(item);
      if (t) t.setAttribute('aria-expanded', 'false');
      var p = panelOf(item);
      if (p) {
        if (immediate) p.hidden = true;
        else window.setTimeout(function () {
          if (!item.classList.contains('is-open')) p.hidden = true;
        }, 200);
      }
      if (current === item) current = null;
    }

    function closeAll() {
      items.forEach(function (i) { hide(i); });
      current = null;
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        window.clearTimeout(openTimer);
        // If a panel is already open, swap immediately — no intent delay.
        if (current) { show(item); return; }
        openTimer = window.setTimeout(function () { show(item); }, OPEN_DELAY);
      });

      // Keyboard and touch-capable laptops: focus opens it too.
      item.addEventListener('focusin', function () {
        window.clearTimeout(closeTimer);
        show(item);
      });

      var trigger = triggerOf(item);
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          // On a coarse pointer the first tap opens rather than navigates.
          if (window.matchMedia('(hover: none)').matches && current !== item) {
            e.preventDefault();
            show(item);
          }
        });
      }
    });

    // Closing is governed by leaving the whole header region, not the item,
    // so travelling down into the panel keeps it open.
    var region = root.closest('.ld-header') || root;

    region.addEventListener('mouseleave', function () {
      window.clearTimeout(openTimer);
      closeTimer = window.setTimeout(closeAll, CLOSE_GRACE);
    });
    region.addEventListener('mouseenter', function () {
      window.clearTimeout(closeTimer);
    });

    region.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!region.contains(document.activeElement)) closeAll();
      }, 0);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !current) return;
      var t = triggerOf(current);
      closeAll();
      if (t) t.focus();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mega-root]').forEach(initMega);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
